import React, { useState } from 'react';
import { LanguageProvider } from './components/LanguageContext';
import WelcomeScreen from './components/WelcomeScreen';
import QuizScreen from './components/QuizScreen';
import ResultsScreen from './components/ResultsScreen';
import './App.css';

function App() {
  const [currentScreen, setCurrentScreen] = useState('welcome');
  const [results, setResults] = useState(null);

  const handleStartQuiz = () => {
    setCurrentScreen('quiz');
  };

  const handleQuizComplete = (personalityType, scores) => {
    setResults({ personalityType, scores });
    setCurrentScreen('results');
  };

  const handleRestart = () => {
    setCurrentScreen('welcome');
    setResults(null);
  };

  const renderCurrentScreen = () => {
    switch (currentScreen) {
      case 'welcome':
        return <WelcomeScreen onStartQuiz={handleStartQuiz} />;
      case 'quiz':
        return <QuizScreen onComplete={handleQuizComplete} />;
      case 'results':
        return (
          <ResultsScreen 
            personalityType={results.personalityType}
            scores={results.scores}
            onRestart={handleRestart}
          />
        );
      default:
        return <WelcomeScreen onStartQuiz={handleStartQuiz} />;
    }
  };

  return (
    <LanguageProvider>
      <div className="App">
        {renderCurrentScreen()}
      </div>
    </LanguageProvider>
  );
}

export default App;
